/**
 * Singleton bridge for TutorConfirmDialog (legacy $root.$confirm parity).
 */
let confirmApi = null;

export function registerTutorConfirm(api) {
  confirmApi = api;
}

/**
 * @param {string} message HTML allowed
 * @param {string} [alertType='error']
 * @param {object} [options]
 * @returns {Promise<boolean|{result:boolean,submitcomplete?:Function}>}
 */
export function openTutorConfirm(message, alertType, options) {
  if (!confirmApi?.open) {
    console.error("TutorConfirmDialog is not mounted");
    return Promise.resolve(false);
  }
  return confirmApi.open(message, alertType, options);
}
